// import { http } from "@/libs/axios.js";
import Vue from "vue";

const CONFIG_API = {
  orderBooking: "order/submit/booking",
  bookingInfo: "order/submit/booking-info",
  placeorder: "order/submit/create",
  city: "/address/search-city", //城市搜索
  orderList: "/order/order/list", //订单列表
  payMethodOffline: "/order/order/pay-method-offline", //线下支付方式
  orderPay: "/order/order/pay", //发起支付

  orderInfo: "/order/order/cruise-info", //平台直采 - 邮轮订单详情
  orderStoreInfo: "/order/shop-order/cruise-info", //店铺分销 - 邮轮订单详情
  orderLineInfo: "/order/order/line-info", //平台直采 - 度假订单详情
  orderStoreLineInfo: "/order/shop-order/line-info", //店铺分销 - 度假订单详情
  orderStatusInfo: "/order/order/status-info", //订单详情状态
  remarkList: "/order/order/remark-list", //平台直采 - 备注列表
  remarkStoreList: "/order/shop-order/remark-list", //店铺分销 - 备注列表
  addRemark: "/order/order/remark-add", //添加备注
  addRemarkStore: "/order/shop-order/remark-add", //店铺分销添加备注
  confirmInfo: "/order/order/confirm-info", //确认单详情
  confirmDownload: "/order/order/confirm-download", //确认单下载
  confirmSign: "/order/order/confirm-sign", //确认单签约
  touristList: "/order/order/tourist-list", //平台直采 - 游客列表
  storeTouristList: "/order/shop-order/tourist-list", //店铺分销 - 游客列表
  touristEdit: "/order/order/tourist-edit", //平台直采 - 游客单个编辑
  storeTouristEdit: "/order/shop-order/tourist-edit", //店铺分销 -  游客单个编辑
  touristAdd: "/order/order/tourist-add", //批量游客新增
  touristSeaImport: "/order/order/tourist-sea-import", //海轮导入接口
  touristRiverImport: "/order/order/tourist-river-import", //河轮导入接口
  touristCabin: "/order/order/tourist-cabin", //游客批量回显
  touristIdentityType: "/order/order/tourist-identity-type", //游客身份类型获取
  cabinAllocationList: "/order/order/cabin-allocation-list", //分房列表
  cabinTouristList: "/order/order/cabin-tourist-list", //游客分房有效的游客列表
  cabinAllocationCut: "/order/order/cabin-allocation-cut", //游客分房 修改入住人 --切舱-- 保存
  cabinAllocation: "/order/order/cabin-allocation", //游客分房 修改入住人--散卖-- 保存
  cabinCompleteInfo: "/order/order/cabin-complete-info", //游客分房完成--切舱 信息检查
  cabinComplete: "/order/order/cabin-complete", //游客分房完成
  orderCancel: "/order/order/cancel", //平台直采 - 取消订单
  orderStoreCancel: "/order/shop-order/cancel", //店铺分销 - 取消订单
  operatingList: "/order/order/operating-list", //操作记录
  lossInitiate: "/order/order/loss-initiate", //核损 整单核损或者指定人核损
  touristValidList: "/order/order/tourist-loss-list", //指定人核损 游客列表
  lossWithdraw: "/order/order/loss-withdraw", //核损撤销
  lossRefund: "/order/order/loss-refund", //核损退款
  lossContinueTravel: "/order/order/loss-continue-travel", //损继续出游
  lossReInitiate: "/order/order/loss-re-initiate", //核损重新发起
  refundInitiate: "/order/order/refund-initiate", //发起退款
  refundDetail: "/order/order/refund-detail", //退款详情
  refundDetailStore: "/order/shop-order/refund-detail", //退款详情
  receiptSubmit: "/order/order/receipt-submit", //提交水单
  receiptDetail: "/order/order/receipt", //水单详情
  receiptApprovalDetail: "/order/order/receipt-approval-detail", //水单审批详情
  getReceiptOrder: "/order/order/get-order", //水单关联订单
  orderStoreList: "/order/shop-order/list", // 获取店铺分销订单
  refundStoreDetail: "/order/shop-order/refund-manage", // 店铺分销 - 退款
  editRebate: "/order/shop-order/adjust-commission", // 店铺分销 - 详情 - 调整返佣
  shopChangeAmount: '/order/order/change-amount', // 店铺分销 - 价格调整

  lineOrderBooking: "/order/submit/line-booking",
  uploadContract: "/order/shop-order/upload-contract", // 上传旅游合同
  uploadDepartureNotice: "/order/shop-order/upload-departure-notice", // 上传出团通知书
  upgradeProject: "/order/order/up-list", //升级项目列表
  addUpgradeProject: "/order/order/up-add", //保存升级项目
  signupUpgradeProjectList: "/order/order/signup-list", //已报名升级项目

  /******************* 海外游轮 S /*******************/
  cruiseTicketBooking: '/order/submit/cruise-ticket-booking',
  cruiseTicketBookinfo: '/order/submit/cruise-ticket-bookinfo',
  cruiseTicketTouristNum: "/order/submit/cruise-ticket-step1",
  cruiseTicketRoomType: "/order/submit/cruise-ticket-step2",
  cruiseTicketCreate: '/order/submit/cruise-ticket-create',
  cruiseTicketDeck: '/order/submit/cruise-ticket-step3', // 房号/甲板
  touristPrices: '/auto/cruise-auto/tourist-prices'
  /******************* 海外游轮 E /*******************/
};

// 提交预订生成下单信息
export function submitOrderBooking(data = {}) {
  return Vue.$axios.post(CONFIG_API.orderBooking, { data });
}

// 获取下单信息 https://www.tapd.cn/62735598/markdown_wikis/show/#1162735598001000698
export function getBookingInfoByNo(data = {}) {
  return Vue.$axios.post(CONFIG_API.bookingInfo, { data });
}

// 下单
export function createOrder(data = {}) {
  return Vue.$axios.post(CONFIG_API.placeorder, { data });
}

// let config = {
//   baseURL: "/api",
//   headers: {
//     "Content-Type": "application/json",
//     token: localStorage.getItem("token")
//   }
// };

// 获取城市
export function getSearchCity(data) {
  return Vue.$axios.post(CONFIG_API.city, { data });
}
//获取平台直销订单列表
export function getOrderList(data) {
  return Vue.$axios.post(CONFIG_API.orderList, { data });
}
//获取店铺分销订单列表
export function getOrderStoreList(data) {
  return Vue.$axios.post(CONFIG_API.orderStoreList, { data });
}
//获取分销商订单列表支付方式
export function PayMethodOffline(data) {
  return Vue.$axios.post(CONFIG_API.payMethodOffline, { data });
}
//获取分销商订单支付
export function saveOrderPay(data) {
  return Vue.$axios.post(CONFIG_API.orderPay, { data });
}

/**
 * 分销商订单详情
 * **/
export function getOrderStatusInfo(data) {
  return Vue.$axios.post(CONFIG_API.orderStatusInfo, { data });
}

/**
 * 平台直采-店铺订单详情
 * **/
export function getOrderInfo(data) {
  return Vue.$axios.post(CONFIG_API.orderInfo, { data });
}
/**
 * 平台直采-度假订单详情
 * **/
export function getOrderLineInfo(data) {
  return Vue.$axios.post(CONFIG_API.orderLineInfo, { data });
}

/**
 * 店铺分销-店铺订单详情
 * **/
export function getStoreOrderInfo(data) {
  return Vue.$axios.post(CONFIG_API.orderStoreInfo, { data });
}
/**
 * 店铺分销-度假订单详情
 * **/
export function getStoreOrderLineInfo(data) {
  return Vue.$axios.post(CONFIG_API.orderStoreLineInfo, { data });
}

/**
 * 平台直采 - 订单备注列表
 * **/
export function getRemarkList(data) {
  return Vue.$axios.post(CONFIG_API.remarkList, { data });
}

/**
 * 店铺分销 - 订单备注列表
 * **/
export function getRemarkStoreList(data) {
  return Vue.$axios.post(CONFIG_API.remarkStoreList, { data });
}

/**
 * 平台直销添加备注
 * **/
export function saveRemark(data) {
  return Vue.$axios.post(CONFIG_API.addRemark, { data });
}

/**
 * 店铺分销添加备注
 * **/
export function saveStoreRemark(data) {
  return Vue.$axios.post(CONFIG_API.addRemarkStore, { data });
}
/**
 * 分销商订单确认单详情
 * **/
export function getConfimInfo(data) {
  return Vue.$axios.post(CONFIG_API.confirmInfo, { data });
}
/**
 * 分销商订单确认单下载
 * **/
export function confimDownload(data) {
  return Vue.$axios.post(CONFIG_API.confirmDownload, { data });
}
/**
 * 分销商订单确认单签约
 * **/
export function confirmSign(data) {
  return Vue.$axios.post(CONFIG_API.confirmSign, { data });
}

/**
 * 平台直采订单游客列表
 * **/
export function getTouristList(data) {
  return Vue.$axios.post(CONFIG_API.touristList, { data });
}

/**
 * 店铺分销订单游客列表
 * **/
export function getStoreTouristList(data) {
  return Vue.$axios.post(CONFIG_API.storeTouristList, { data });
}
/**
 * 分销商订单批量上传游客
 * **/
export function saveTouristAdd(data) {
  return Vue.$axios.post(CONFIG_API.touristAdd, { data });
}

/**
 * 分销商 批量编辑游客信息回显
 * **/
export function getTouristCabin(data) {
  return Vue.$axios.post(CONFIG_API.touristCabin, { data });
}
/**
 * 平台直采 分销商单个游客证件类型
 * **/
export function saveTouristEdit(data) {
  return Vue.$axios.post(CONFIG_API.touristEdit, { data });
}
/**
 * 店铺分销 分销商单个游客证件类型
 * **/
export function saveStoreTouristEdit(data) {
  return Vue.$axios.post(CONFIG_API.storeTouristEdit, { data });
}
/**
 * 分销商单个游客证件类型
 * **/
export function getTouristIdentityType(data) {
  return Vue.$axios.post(CONFIG_API.touristIdentityType, { data });
}

/**
 * 平台直销 - 订单取消
 * **/
export function orderCancel(data) {
  return Vue.$axios.post(CONFIG_API.orderCancel, { data });
}

/**
 * 店铺分销 - 订单取消
 * **/
export function orderStoreCancel(data) {
  return Vue.$axios.post(CONFIG_API.orderStoreCancel, { data });
}

/**
 * 分销商订单操作记录
 * **/
export function operatingList(data) {
  return Vue.$axios.post(CONFIG_API.operatingList, { data });
}
/**
 * 分销商订单发起核损
 * **/
export function lossInitiate(data) {
  return Vue.$axios.post(CONFIG_API.lossInitiate, { data });
}

/**
 * 分销商订单有效游客列表
 * **/
export function getTouristValidList(data) {
  return Vue.$axios.post(CONFIG_API.touristValidList, { data });
}

/*
 * 分销商订单核损撤回
 * **/
export function lossWithdraw(data) {
  return Vue.$axios.post(CONFIG_API.lossWithdraw, { data });
}
/**
 * 分销商订单核损退款
 * **/
export function lossRefund(data) {
  return Vue.$axios.post(CONFIG_API.lossRefund, { data });
}
/**
 * 分销商订单损继续出游
 * **/
export function lossContinueTravel(data) {
  return Vue.$axios.post(CONFIG_API.lossContinueTravel, { data });
}
/**
 * 分销商订单核损重新发起
 * **/
export function lossReInitiate(data) {
  return Vue.$axios.post(CONFIG_API.lossReInitiate, { data });
}
/**
 * 分销商订单发起退款
 * **/
export function refundInitiate(data) {
  return Vue.$axios.post(CONFIG_API.refundInitiate, { data });
}
/**
 * 平台直销订单退款详情
 * **/
export const refundDetail = (data = {}) =>
  Vue.$axios.post(CONFIG_API.refundDetail, { data });

/**
 * 店铺分销订单退款详情
 * **/
export function refundDetailStore(data) {
  return Vue.$axios.post(CONFIG_API.refundDetailStore, { data });
}

/**
 * 分销商订单分房列表
 * **/
export function getCabinAllocationList(data) {
  return Vue.$axios.post(CONFIG_API.cabinAllocationList, { data });
}

/**
 * 分销商订单获取有效用户数据
 * **/
export function cabinTouristList(data) {
  return Vue.$axios.post(CONFIG_API.cabinTouristList, { data });
}

/**
 * 分销商订单 游客分房 修改入住人 --切舱-- 保存
 * **/
export function cabinAllocationCut(data) {
  return Vue.$axios.post(CONFIG_API.cabinAllocationCut, { data });
}

/**
 * 分销商订单 游客分房 修改入住人--散卖-- 保存
 * **/
export function cabinAllocation(data) {
  return Vue.$axios.post(CONFIG_API.cabinAllocation, { data });
}
/**
 * 分销商订单 游客分房完成--切舱 信息检查
 * **/
export function cabinCompleteInfo(data) {
  return Vue.$axios.post(CONFIG_API.cabinCompleteInfo, { data });
}
/**
 * 分销商订单 游客分房完成
 * **/
export function cabinComplete(data) {
  return Vue.$axios.post(CONFIG_API.cabinComplete, { data });
}

/**
 * 分销商订单 提交水单
 * **/
export function receiptSubmit(data) {
  return Vue.$axios.post(CONFIG_API.receiptSubmit, { data });
}
/**
 * 分销商订单 水单详情
 * **/
export function receiptDetail(data) {
  return Vue.$axios.post(CONFIG_API.receiptDetail, { data });
}
/**
 * 分销商订单 水单审批详情
 * **/
export function receiptApprovalDetail(data) {
  return Vue.$axios.post(CONFIG_API.receiptApprovalDetail, { data });
}
/**
 * 分销商订单 水单关联订单
 * **/
export function getReceiptOrder(data) {
  return Vue.$axios.post(CONFIG_API.getReceiptOrder, { data });
}

export function submitLineOrderBooking(data) {
  return Vue.$axios.post(CONFIG_API.lineOrderBooking, { data });
}

/**
 * 店铺分销 - 退款详情
 * **/
export function postRefundStoreDetail(data) {
  return Vue.$axios.post(CONFIG_API.refundStoreDetail, { data });
}
/**
 * 店铺分销 - 调整返佣
 * **/
export function editRebate(data) {
  return Vue.$axios.post(CONFIG_API.editRebate, { data });
}
/**
 * 店铺分销 - 上传旅游合同
 * **/
export function uploadContract(data) {
  return Vue.$axios.post(CONFIG_API.uploadContract, { data });
}
/**
 * 店铺分销 - 上传出团通知书
 * **/
export function uploadDepartureNotice(data) {
  return Vue.$axios.post(CONFIG_API.uploadDepartureNotice, { data });
}
/**
 * 产品预订 - 升级项目
 * **/
export function getUpgradeProject(data) {
  return Vue.$axios.post(CONFIG_API.upgradeProject, { data });
}
/**
 * 产品预订 - 添加升级项目
 * **/
export function addUpgradeProject(data) {
  return Vue.$axios.post(CONFIG_API.addUpgradeProject, { data });
}
/**
 * 产品预订 - 已报名升级项目
 * **/
export function signupUpgradeProjectList(data) {
  return Vue.$axios.post(CONFIG_API.signupUpgradeProjectList, { data });
}

/**
 * 
 * @param {object} data 
 * @param {string} data.order_no 
 * @param {string|number} data.type 
 * @param {string} data.amount 
 * @param {string} data.title 
 * @param {string} data.remark 
 * @returns 
 */
export function updateShopOrderPrice(data){
  return Vue.$axios.post(CONFIG_API.shopChangeAmount, {data})
}


/**************************************** 海外游轮下单流程 S ****************************************/

export function submitCruiseTicketBooking(data) {
  return Vue.$axios.post(CONFIG_API.cruiseTicketBooking, { data })
}
/**
 * 预订信息
 * @param {object} data
 * @param { string } data.booking_no 
 * @param { string } data.step
 */
export function getCruiseTicketBookinfo(data) {
  return Vue.$axios.post(CONFIG_API.cruiseTicketBookinfo, { data })
}

/**
 * 保存游客数量 
 * @param { object } data 
 * @param { string } data.booking_no
 * @param { number } data.tourist_num
 * @param { Array<number> } data.tourist_ages
 * @param { string } data.reside
 */
export function saveCruiseTicketTouristNum(data) {
  return Vue.$axios.post(CONFIG_API.cruiseTicketTouristNum, { data })
}

/**
 * 选择舱房
 * @see https://www.apifox.cn/web/project/1407556/apis/api-42171323
 * @param { object } data 
 * @param { string } data.cabin_type
 * @param { string } data.cabin_code
 * @param { string } data.cabin_name
 * @param { string } data.cabin_url
 * @param { string } data.package_name
 */
export function saveCruiseTicketRoomType(data) {
  return Vue.$axios.post(CONFIG_API.cruiseTicketRoomType, { data })
}

export function saveCruiseTicketRoomDeck(data) {
  return Vue.$axios.post(CONFIG_API.cruiseTicketDeck, {data});
}

/**
 * 
 * @param {object} data 
 * @param { string } data.booking_no
 * @param { Array } data.tourists
 * @returns 
 */
export function createCruiseTicketOrder(data) {
  return Vue.$axios.post(CONFIG_API.cruiseTicketCreate, { data }, {
    timeout: 120 * 1000
  })
}
/**
 * @desc 获取舱房价格
 * @see https://www.apifox.cn/web/project/1407556/apis/api-43444820
 * @returns 
 */
export function getTouristPrices(data) {
  return Vue.$axios.post(CONFIG_API.touristPrices, {data}, {
    baseURL: process.env.API_HOST
  })
}
/**************************************** 海外游轮下单流程 E ****************************************/